export default __webpack_public_path__ + "b08a405737995e213a9ef7de724f5530.png";